import api from '@/utils/axios';
import { fetchEmployeeProfileOptions } from '@/api/employeesApi';
import { createReferenceOptionsCache } from '@/utils/referenceOptionsCache';
import { normalizeOrgReferenceOptions, normalizeOrgReferenceRow } from '@/utils/orgReferenceText';

const optionsCache = createReferenceOptionsCache((includeInactive) =>
  fetchEmployeeProfileOptions({ include_inactive: includeInactive ? 1 : undefined })
    .then(normalizeOrgReferenceOptions)
);

/**
 * Org reference reads — temporary reuse of employee profile options endpoint.
 * See docs/ORG_REFERENCE_API.md §UI reads and docs/SETTINGS_ORG_REFERENCE_LIST_PATTERN.md
 */
export function fetchOrgReferenceOptions(options = {}) {
  return optionsCache.fetch(options);
}

export function invalidateOrgReferenceOptions() {
  optionsCache.invalidate();
}

async function postManage(route, action, payload) {
  try {
    const response = await api.post(route, { action, ...payload });
    if (!response.data?.success) {
      const error = new Error(response.data?.error?.message || 'Request failed');
      error.code = response.data?.error?.code || null;
      throw error;
    }
    return normalizeOrgReferenceRow(response.data.data);
  } catch (err) {
    if (err instanceof Error && err.message && !err.error) {
      throw err;
    }
    const message = err?.message || err?.error?.message || 'Request failed';
    const error = new Error(message);
    error.code = err?.response?.data?.error?.code || err?.code || null;
    throw error;
  }
}

export const orgReferenceApi = {
  locations: {
    create: (payload) => postManage('locations/manage', 'create', payload),
    update: (payload) => postManage('locations/manage', 'update', payload),
    delete: ({ location_id }) => postManage('locations/manage', 'delete', { location_id }),
  },
  subDepartments: {
    create: (payload) => postManage('sub-departments/manage', 'create', payload),
    update: (payload) => postManage('sub-departments/manage', 'update', payload),
    delete: ({ sub_department_id }) =>
      postManage('sub-departments/manage', 'delete', { sub_department_id }),
  },
  teams: {
    create: (payload) => postManage('teams/manage', 'create', payload),
    update: (payload) => postManage('teams/manage', 'update', payload),
    delete: ({ team_id }) => postManage('teams/manage', 'delete', { team_id }),
  },
};
